import type { Icon } from '@phosphor-icons/react'
import type { ReactNode } from 'react'

import { kuniriIconWeight } from '@/lib/icons'

interface CalloutProps {
  icon: Icon
  title: string
  children: ReactNode
  tone?: 'neutral' | 'mint' | 'salmon'
  className?: string
}

const TONE_CLASS = {
  neutral: 'border-line bg-[#f7f8f8]',
  mint: 'border-line bg-[#f7f8f8]',
  salmon: 'border-coral/25 bg-[var(--salmon-soft)]',
} as const

/**
 * Shared inline callout for privacy notes, meeting points and participation
 * states. Brand-token colours only; title is a real heading-like label and the
 * body stays selectable text.
 */
export function Callout({
  icon: CalloutIcon,
  title,
  children,
  tone = 'neutral',
  className,
}: CalloutProps) {
  return (
    <div
      className={`flex items-start gap-3 rounded-[20px] border p-4 ${TONE_CLASS[tone]} ${className ?? ''}`}
    >
      <CalloutIcon
        size={22}
        weight={kuniriIconWeight}
        aria-hidden="true"
        className="mt-0.5 shrink-0 text-teal"
      />
      <div className="min-w-0 space-y-1">
        <p className="font-body text-[15px] font-bold text-deep">
          {title}
        </p>
        <div className="text-[15px] leading-relaxed text-muted">{children}</div>
      </div>
    </div>
  )
}
